import React from 'react'
import { StyledTheme } from 'theme'
import styled from 'styled-components'
import { Box } from 'components/styled/containers/box'

interface PageContentProps {
  size?: keyof StyledTheme['size']['pageContent']
}

const StyledPageContent = styled(Box)<Required<PageContentProps>>`
  margin-left: auto;
  margin-right: auto;

  width: ${({ theme, size }) => theme.size.pageContent[size]};

  padding-left: ${({ theme }) => theme.space.s40};
  padding-right: ${({ theme }) => theme.space.s40};
  max-width: 100%;

  ${({ theme }) => theme.mediaQuery.phone} {
    padding: 0 ${({ theme }) => theme.space.s20};
  }
`

export const PageContent: React.FC<PageContentProps> = ({
  children,
  size = 'medium',
  ...props
}) => {
  return (
    <StyledPageContent size={size} {...props}>
      {children}
    </StyledPageContent>
  )
}
